import { html, LitElement } from 'lit';
import { styles } from './view/styles';
import { WEB_COMPONENT_RESUME_INTEGRITY_MONITORING } from '../../../../../webcomponents.constants';
import { customElement } from 'lit/decorators.js';
import { translateFn } from '../../../../../utils/translator.helper';
import { FontSizes, LineHeights } from '../../../../../types/common/types';

@customElement(WEB_COMPONENT_RESUME_INTEGRITY_MONITORING)
export class GzResumeIntegrityMonitorWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  protected render() {
    return html`<gz-text lineHeight="${LineHeights.SMALL}" fontSize="${FontSizes.HEADING_6}">
      ${translateFn('This action will resume integrity monitoring for the selected endpoints.')}
    </gz-text>`;
  }
}
